module.exports = __webpack_public_path__ + "static/img/card1.83a4aa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card1.jpg
// module id = xV6w
// module chunks = 0